<template>
  <collapseItem v-if="toggle" :id="id" class="chart-box" :visible="isVisible">
    <table class="chart-table">
      <slot></slot>
    </table>
  </collapseItem>
  <div v-else class="chart-box">
    <table class="chart-table">
      <slot></slot>
    </table>
    <div v-show="gradient" class="gradient" :class="{ hide: isVisible }"></div>
  </div>
</template>

<script>
import collapseItem from "@/components/collapse/CollapseItem";

export default {
  name: "ChartBox",
  components: {
    collapseItem,
  },
  props: {
    toggle: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    id: { type: String, default: "" },
  },
  computed: {
    isVisible() {
      return this.$parent.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.chart-box {
  position: relative;
  &.b-collapse {
    max-height: 0;
    transition: 0.4s;
    overflow: hidden;
    display: block;
    &.hide {
      max-height: 999vh;
      transition: 1s;
    }
  }
  > .chart-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid $secondary;
    table-layout: fixed;
  }
  &.-hide {
    :deep(.chart-table),
    :deep(.chart-data) {
      border-top: none;
    }
  }
  &.collapsing {
    transition: all 300ms 0s ease;
    position: relative;
    overflow: hidden;
  }
  > .gradient {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(to bottom, rgba($white, 0), rgba($white, 1));
    &.hide {
      background: linear-gradient(to bottom, rgba($white, 0), rgba($white, 0));
    }
  }
}
</style>
